"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "event-chart"
  }, [_c("p", [_vm._v("Inquiry Value")]), _c("el-table", {
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "380"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "categorization",
      label: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row[""]) + " ")];
      }
    }])
  }), _vm._l(_vm.coordinatorList, function (coordinator) {
    return _c("el-table-column", {
      key: coordinator.id,
      staticStyle: {
        "word-wrap": "break-word!important",
        overflow: "hidden!important"
      },
      attrs: {
        prop: coordinator.fullName,
        label: coordinator.fullName
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function (scope) {
          return [_vm._v(" " + _vm._s(scope.row[coordinator.fullName] || 0) + " ")];
        }
      }], null, true)
    });
  })], 2)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;